import React from "react";
import { Box } from "@mui/material";

const ContentLayout = ({ children }) => {
  return (
    <Box sx={{ height: "100%", width: "100%", overflowY: "auto" }}>
      {children}
    </Box>
  );
};

export default ContentLayout;
